<template>
  <div class="page-main">
    <e-tabs :list="this.$constant.tabListSupplier()" isJump />
    <!-- 表格操作条 -->
    <vxe-toolbar ref="refToolbar" size="mini" import export print custom :loading="loading">
      <template #buttons>
        <span class="m-r-5">关联类目</span>
        <b-goods-texture
          :data.sync="categoryTextureData"
          :isInit="false"
          :isLoadTexture="false"
          width="400px"
        />
        <span class="m-l-10">所属地区：</span>
        <div>
          <c-cascader-address :list.sync="address_ids" :showAllLevels="false" checkStrictly />
        </div>
      </template>
      <template #tools>
        <el-button type="success" size="mini" @click="itemDo()">新增供应商 </el-button>
        <el-button type="danger" size="mini" @click="batchDelete">删除供应商 </el-button>
        <el-button type="primary" size="mini" @click="batchBan">激活/禁用供应商 </el-button>
        <el-button
          size="mini"
          title="模板下载"
          class="el-icon-notebook-2"
          circle
          plain
          @click="downloadModule"
        />
      </template>
    </vxe-toolbar>

    <!-- 表格 -->
    <vxe-grid
      ref="refTable"
      :loading="loading"
      :height="this.$util.getViewHeight() - 187"
      :columns="tableColumn"
      :data="tableDataMain"
      :import-config="importConfig"
      :mouse-config="{ selected: false }"
      :export-config="{ type: ['xlsx'], types: ['xlsx'] }"
    >
      <!-- slot_header -->
      <template #header_input="{ column }">
        <c-table-header
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          @change="headerFilterChange"
        />
      </template>

      <!-- slot_default -->
      <template #default_mu_ban_ming_cheng_list="{ row }">
        {{ row.mu_ban_ming_cheng_list.join('、') }}
      </template>
      <template #default_mu_ban_guan_jian_ci_list="{ row }">
        {{ row.mu_ban_guan_jian_ci_list.join('、') }}
      </template>
      <template #default_state="{ row }">
        <span v-if="row.state === '禁用'" :style="{ color: '#999' }">{{ row.state }}</span>
        <span v-if="row.state === '激活'" :style="{ color: '#67c23a' }">{{ row.state }}</span>
      </template>
      <template #default_operate="{ row }">
        <el-link type="success" @click="itemSync(row)">同步UUID</el-link>
        <el-link type="primary" @click="itemDo(row)">编辑</el-link>
        <el-link type="danger" @click="itemDelete(row)">删除</el-link>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-增改供应商 -->
    <PopupDo
      v-if="isShowPopupDo"
      :show.sync="isShowPopupDo"
      :detailId="detailId"
      @success="getListData"
    />

    <!-- 弹窗-同步 -->
    <PopupSync v-if="isShowPopupSync" :show.sync="isShowPopupSync" :data.sync="itemSyncObj" />

    <!-- 弹窗-导入 -->
    <PopupImport
      v-if="isShowPopupImport"
      :show.sync="isShowPopupImport"
      :isError="isError"
      :uuid="uuid"
      :list="importTableData"
      @success="getListData"
    />
  </div>
</template>

<script>
import PopupDo from './popup-do'
import PopupSync from './popup-sync'
import PopupImport from './popup-import'
export default {
  components: {
    PopupDo,
    PopupSync,
    PopupImport
  },
  data() {
    return {
      loading: true,

      categoryTextureData: {
        category_list: []
      },
      address_ids: [],

      banIds: [],
      remvoeIds: [],

      filterData: {},
      sortData: {
        id: 'desc'
      },
      headerFilterUrl: '/admin/supplier/searchHeard',
      tableColumn: [
        {
          type: 'checkbox',
          width: 40
        },
        {
          field: 'id',
          title: '供应商编号',
          width: 80,
          slots: { header: 'header_input' }
        },
        {
          field: 'supplier_name',
          title: '供应商名称',
          width: 240,
          slots: { header: 'header_input' }
        },
        // { field: 'category1', title: '一级类目', width: 100 },
        // { field: 'category2', title: '二级类目', width: 100 },
        // { field: 'category3', title: '三级类目', width: 100 },
        // { field: 'category4', title: '四级类目', width: 100 },
        {
          field: 'mu_ban_ming_cheng_list',
          title: '经营商品',
          slots: { header: 'header_input', default: 'default_mu_ban_ming_cheng_list' }
        },
        {
          field: 'mu_ban_guan_jian_ci_list',
          title: '商品关键词',
          slots: { header: 'header_input', default: 'default_mu_ban_guan_jian_ci_list' }
        },
        {
          field: 'wei_xin_code',
          title: '微信号',
          slots: { header: 'header_input' }
        },
        {
          field: 'linkman',
          title: '联系人',
          width: 100,
          slots: { header: 'header_input' }
        },
        {
          field: 'linkman_phone',
          title: '联系电话',
          width: 100,
          slots: { header: 'header_input' }
        },
        {
          field: 'address_str',
          title: '联系地址',
          width: 200,
          slots: { header: 'header_input' }
        },
        {
          field: 'address_detail',
          title: '详细地址',
          width: 200,
          slots: { header: 'header_input' }
        },
        {
          field: 'remark',
          title: '备注',
          width: 200,
          slots: { header: 'header_input' }
        },
        {
          field: 'state',
          title: '状态',
          width: 80,
          slots: { header: 'header_input', default: 'default_state' }
        },
        // {
        //   field: 'is_customer',
        //   title: '已关联客户',
        //   width: 100,
        //   slots: { header: 'header_input' }
        // },
        // {
        //   field: 'used_name',
        //   title: '曾用名',
        //   width: 80,
        //   slots: { header: 'header_input' }
        // },
        {
          title: '操作',
          width: 160,
          slots: { default: 'default_operate' }
        }
      ],
      tableDataMain: [],
      importConfig: {
        remote: true,
        importMethod: this.importMethod,
        modes: ['insert'],
        type: ['xlsx'],
        types: ['xlsx']
      },
      pageOptions: {
        ...this.$constant.page
      },
      isShowPopupDo: false,
      detailId: '',

      isShowPopupSync: false,
      itemSyncObj: {
        id: '',
        company_uuid: '',
        supplier_name: '',
        customer_uuid: '',
        customer_name: ''
      },

      isShowPopupImport: false,
      isError: '',
      uuid: '',
      importTableData: []
    }
  },
  computed: {
    category_names() {
      let result = this.categoryTextureData.category_list.map((item) => item.name)
      return result
    }
  },
  watch: {
    category_names(newVal, oldVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.searchListData()
      }
    },
    address_ids(newVal, oldVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.searchListData()
      }
    }
  },
  created() {
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.refTable.connect(this.$refs.refToolbar)
      this.getListData()
    })
  },
  methods: {
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取数据列表
    getListData() {
      this.loading = true
      let filterData = { ...this.filterData }
      let category_len = this.category_names.length
      if (category_len)
        filterData[`category${category_len}`] = this.category_names[category_len - 1]
      if (this.address_ids.length) filterData.address_ids = this.address_ids.join(',')

      this.$api({
        method: 'post',
        url: '/admin/supplier',
        data: {
          currentPage: this.pageOptions.currentPage,
          pageSize: this.pageOptions.pageSize,
          sortData: this.sortData,
          filterData
        }
      })
        .then((res) => {
          if (res.status === 200 && res.data.state === 'ok') {
            this.tableDataMain = res.data.page.list
            this.pageOptions.pageSize = res.data.page.pageSize
            this.pageOptions.total = res.data.page.totalRow
            this.pageOptions.currentPage = res.data.page.pageNumber
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 项-增改
    itemDo(row) {
      if (row === undefined) {
        this.detailId = ''
      } else {
        this.detailId = row.id
      }
      this.isShowPopupDo = true
    },
    // 项-同步uuid
    itemSync(row) {
      this.isShowPopupSync = true
      this.itemSyncObj = this.$util.deepCopy(row)
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm('您确认要删除该数据?', '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/supplier/deleteVue',
            params: {
              id: row.id
            }
          }).then((res) => {
            if (res.data.state === 'ok') {
              this.$message.success('删除成功')
              this.getListData()
            }
          })
        })
        .catch(() => {})
    },
    // 批量-激活/禁用
    batchBan() {
      const $grid = this.$refs.refTable
      const selectRecords = $grid.getCheckboxRecords()
      this.banIds = []
      for (let i = 0; i < selectRecords.length; i++) {
        this.banIds.push(selectRecords[i].id)
      }
      if (selectRecords.length > 0) {
        this.$confirm(`您确认要激活/禁用${this.banIds.length}个供应商?`, '提示')
          .then(() => {
            this.$api({
              method: 'get',
              url: '/admin/supplier/banBatchVue',
              params: {
                banIds: this.banIds
              }
            }).then((res) => {
              if (res.data.state === 'ok') {
                this.$message.success('批量删除成功')
                this.getListData()
              } else {
                this.$message.erroe(res.data.msg)
              }
            })
          })
          .catch(() => {})
      } else {
        this.$message.error('请先选择')
      }
    },
    // 批量-删除
    batchDelete() {
      const $grid = this.$refs.refTable
      const selectRecords = $grid.getCheckboxRecords()
      this.remvoeIds = []
      for (let i = 0; i < selectRecords.length; i++) {
        this.remvoeIds.push(selectRecords[i].id)
      }
      if (selectRecords.length > 0) {
        this.$confirm(`您确认要删除${this.remvoeIds.length}条数据?`, '提示')
          .then(() => {
            this.$api({
              method: 'get',
              url: '/admin/supplier/deleteBatchVue',
              params: {
                remvoeIds: this.remvoeIds
              }
            }).then((res) => {
              if (res.data.state === 'ok') {
                this.$message.success('批量删除成功')
                this.getListData()
              }
            })
          })
          .catch(() => {})
      } else {
        this.$message.error('请先选择')
      }
    },
    // 模板下载
    downloadModule() {
      window.open('/template/supplier.xlsx', '_blank')
    },
    // 导入方法
    importMethod({ file }) {
      const formBody = new FormData()
      formBody.append('file', file)
      this.$api({
        method: 'post',
        url: '/admin/supplier/importExcel',
        data: formBody
      }).then((res) => {
        if (res.data.state === 'ok') {
          if (res.data.isError == true) {
            this.importTableData = res.data.supplierListError
          } else {
            this.importTableData = res.data.supplierList
          }
          this.isError = res.data.isError
          this.uuid = res.data.uuid
          this.isShowPopupImport = true
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
